import type Integration from "../../model/Integration";
import API, { responseOf } from "../base";

export const getAll = (organizationId: string): Promise<Integration[]> =>
  responseOf(API.get(`/organizations/${organizationId}/integrations`));

export const create = (
  integration: Integration,
  organizationId: string,
): Promise<Integration> =>
  responseOf(
    API.post(`/organizations/${organizationId}/integrations`, integration),
  );

export const remove = (
  integrationId: string,
  organizationId: string,
): Promise<Integration> =>
  responseOf(
    API.delete(
      `/organizations/${organizationId}/integrations/${integrationId}`,
    ),
  );

export const update = (
  integrationId: string,
  organizationId: string,
  integration: Integration,
): Promise<Integration> =>
  responseOf(
    API.put(
      `/organizations/${organizationId}/integrations/${integrationId}`,
      integration,
    ),
  );
